(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/draws/assets/javascripts/internal/fetch-draws.js') >= 0) return;  svs.modules.push('/components/numbergames/draws/assets/javascripts/internal/fetch-draws.js');

'use strict';

let productMapping;
let DRAW_STATES;
let CURRENT_DRAW_PATHS;

function formatPath(paths) {
  if (!Array.isArray(paths)) paths = [paths];
  paths = paths.filter(path => Boolean(path));
  paths = Array.from(new Set(paths));
  if (!paths.length) {
    throw new Error('No valid paths provided to formatPath');
  }
  return paths.length === 1 ? paths[0] : "/multifetch?urls=".concat(paths.join('|'));
}

function isValidNumber(number) {
  return Number.isFinite(Number(number)) && !isNaN(parseInt(number, 10));
}

function fetchCurrentDrawsWrapper(jupiterCallAsync) {
  return async productDrawIds => {
    if (!productDrawIds || !productDrawIds.length) {
      throw new Error('No productDrawIds provided to fetchCurrentDraws');
    }
    let path;
    try {
      if (!Array.isArray(productDrawIds)) productDrawIds = [productDrawIds];
      path = formatPath(productDrawIds.map(productDrawId => CURRENT_DRAW_PATHS[productDrawId]));
    } catch (error) {
      throw new Error("fetchCurrentDraws: Failed to format API path for current draws from: ".concat(productDrawIds.join(', '), " ").concat(error));
    }
    let response;
    try {
      response = await jupiterCallAsync(path);
    } catch (error) {
      throw new Error("fetchCurrentDraws: Failed to fetch current draws for ".concat(path, " ").concat(error));
    }
    const currentDraws = [];
    const drawsToFetch = [];
    const closedDraws = [];
    try {
      const responses = Array.isArray(response.responses) ? response.responses : [response];
      responses.map(_ref => {
        let {
          draw,
          draws
        } = _ref;
        return draw || draws;
      }).forEach(draw => {
        const current = draw.currentDraws || [draw.currentDraw];
        const future = Array.isArray(draw.futureDraws) ? draw.futureDraws : [draw.futureDraws];
        future.forEach(futureDraw => {
          const productId = futureDraw.productId;
          const productDrawId = productMapping.getProductDrawId(productId);
          const currentDraw = current.find(draw => (draw === null || draw === void 0 ? void 0 : draw.productId) === productId);
          if (currentDraw) {
            currentDraws.push(currentDraw);
            closedDraws.push({
              productId,
              drawNumber: currentDraw.drawNumber - 1,
              drawStateId: DRAW_STATES.CLOSED
            });
          } else {
            drawsToFetch.push({
              productDrawId,
              drawNumber: futureDraw.nextDrawNumber
            });
            drawsToFetch.push({
              productDrawId,
              drawNumber: futureDraw.nextDrawNumber - 1
            });
          }
        });
      });
    } catch (error) {
      throw new Error("fetchCurrentDraws: Failed to parse response from ".concat(path, " ").concat(error));
    }
    return {
      currentDraws,
      drawsToFetch,
      closedDraws
    };
  };
}

function fetchDrawsByDrawIdWrapper(jupiterCallAsync) {
  return async drawIds => {
    if (!Array.isArray(drawIds)) drawIds = [drawIds];
    const allProductDrawIds = productMapping.getAllDrawIds();
    const drawsToFetch = drawIds.filter(drawId => drawId && allProductDrawIds.includes(drawId.productDrawId) && isValidNumber(drawId.drawNumber)).map(_ref2 => {
      let {
        productDrawId,
        drawNumber
      } = _ref2;
      return "/draw/1/".concat(productDrawId, "/draws/").concat(drawNumber);
    });
    if (!drawsToFetch.length) {
      throw new Error('No valid drawIds provided to fetchDrawsByDrawId');
    }
    let path;
    try {
      path = formatPath(drawsToFetch);
    } catch (error) {
      throw new Error("fetchDrawsByDrawId: Failed to format API path for draws by drawId from ".concat(drawsToFetch.join(', '), " ").concat(error));
    }
    let response;
    try {
      response = await jupiterCallAsync(path);
    } catch (error) {
      throw new Error("fetchDrawsByDrawId: Failed to fetch draws for ".concat(path, " ").concat(error));
    }
    const draws = [];
    const closedDraws = [];
    try {
      const responses = Array.isArray(response.responses) ? response.responses : [response];
      responses.forEach(_ref3 => {
        let {
          draw
        } = _ref3;
        if (draw.drawStateId > DRAW_STATES.OPEN) {
          closedDraws.push(draw);
        } else {
          draws.push(draw);
        }
      });
    } catch (error) {
      throw new Error("fetchDrawsByDrawId: Failed to parse response from ".concat(path, " ").concat(error));
    }
    return {
      draws,
      closedDraws
    };
  };
}
if (svs.isServer) {
  const trinidadCore = require('@svenskaspelab/trinidad-core').core;
  ({
    productMapping
  } = trinidadCore.components.require('numbergames', 'product-mapping'));
  ({
    DRAW_STATES,
    CURRENT_DRAW_PATHS
  } = require('../constants.es6'));
  const callAsync = req => async path => {
    try {
      return await trinidadCore.jupiter.callAsync({
        method: 'GET',
        path,
        req
      });
    } catch (error) {
      throw new Error("".concat(error.name, ": ").concat(decodeURIComponent(error.message)));
    }
  };
  module.exports = {
    fetchCurrentDraws: req => fetchCurrentDrawsWrapper(callAsync(req)),
    fetchDrawsByDrawId: req => fetchDrawsByDrawIdWrapper(callAsync(req))
  };
} else {
  productMapping = svs.numbergames.productMapping;
  ({
    DRAW_STATES,
    CURRENT_DRAW_PATHS
  } = svs.numbergames.draws.constants);
  const callAsync = async path => {
    const {
      response
    } = await svs.core.jupiter.callAsync({
      method: 'GET',
      path
    });
    return response;
  };
  Object.assign(svs.numbergames.draws.internal, {
    fetchCurrentDraws: fetchCurrentDrawsWrapper(callAsync),
    fetchDrawsByDrawId: fetchDrawsByDrawIdWrapper(callAsync)
  });
}

 })(window);